// Retrieves and saves user preferences (topics and sources) from Firestore
// to be used in articles fetching

/* previous version (works)
import { reactive } from "vue";
import { db } from "@/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export const preferencesState = reactive({
  topics: [],
  sources: [],
  bookmarks: [],
  userId: null,
  isLoaded: false,

  // Load preferences from Firestore
  async load(user) {
    this.userId = user.uid;
    const ref = doc(db, "preferences", user.uid);
    const snap = await getDoc(ref);

    if (snap.exists()) {
      const data = snap.data();
      this.topics = data.topics || [];
      this.sources = data.sources || [];
      this.bookmarks = data.bookmarks || [];

    } 
    else {
      // create default
      await setDoc(ref, { topics: [], sources: [], user_id: user.uid });
      this.topics = [];
      this.sources = [];
    }

    this.isLoaded = true;
    return { topics: this.topics, sources: this.sources };
  },


  // Save preferences to Firestore
  async save(topics, sources) {
    if (!this.userId) return;

    const ref = doc(db, "preferences", this.userId);

    await setDoc(
      ref,
      {
        topics,
        sources,
        user_id: this.userId,
      },
      { merge: true }
    );

    this.topics = topics;
    this.sources = sources;
  }
});
*/




/* v2

// Revised version - handles empty arrays as null to prevent SQL errors, and adds real-time updates

import { reactive } from "vue";
import { db } from "@/firebase";
import { doc, setDoc, onSnapshot, getDoc } from "firebase/firestore";

// Converts empty arrays → null (prevents backend SQL errors)
function normalize(value) {
  return Array.isArray(value) && value.length === 0 ? null : value;
}

export const preferencesState = reactive({
  topics: null,
  sources: null,
  bookmarks: null,
  userId: null,

  isLoaded: false,
  unsubscribe: null,

  async load(user) {
    if (!user?.uid) return;

    this.userId = user.uid;
    const ref = doc(db, "preferences", user.uid);

    const snap = await getDoc(ref);
    if (!snap.exists()) {
      await setDoc(ref, {
        topics: null,
        sources: null,
        bookmarks: null,
        user_id: user.uid,
      });
    }

    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }

    this.unsubscribe = onSnapshot(ref, (docSnap) => {
      if (!docSnap.exists()) return;

      const data = docSnap.data();

      this.topics = normalize(data.topics);
      this.sources = normalize(data.sources);
      this.bookmarks = normalize(data.bookmarks);
      this.userId = data.user_id;
       console.log("🔥 Bookmarks updated:", this.bookmarks);
      this.isLoaded = true;
    });
  },

  async save(fields = {}) {
    if (!this.userId) return;
    
    const ref = doc(db, "preferences", this.userId);

    const normalized = {};
    for (const key in fields) {
      normalized[key] = normalize(fields[key]);
    }

    await setDoc(
      ref,
      {
        ...normalized,
        user_id: this.userId,
      },
      { merge: true }
    );
  },

  async updateTopics(topics) {
    await this.save({ topics });
  },

  async updateSources(sources) {
    await this.save({ sources });
  },

  async updateBookmarks(bookmarks) {
    await this.save({ bookmarks });
  },

  detach() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }
});
*/


// v3 - Minor refactor to simplify save method parameter
import { reactive } from "vue";
import { db } from "@/firebase";
import { doc, setDoc, onSnapshot, getDoc } from "firebase/firestore";

function normalize(value) {
  if (value === undefined) return null;
  return Array.isArray(value) && value.length === 0 ? null : value;
}

export const preferencesState = reactive({
  topics: null,
  subtopics: null,


  sources: null,
  bookmarks: null,
  userId: null,

  isLoaded: false,
  unsubscribe: null,


  /*
  async load(user) {
    if (!user?.uid) return;

    // Prevent double loading for same user
    if (this.userId === user.uid && this.isLoaded) return;
    
    this.userId = user.uid;
    const ref = doc(db, "preferences", user.uid);

    const snap = await getDoc(ref);

    // Create doc if missing
    if (!snap.exists()) {
      await setDoc(
        ref,
        {
          topics: null,
          sources: null,
          bookmarks: null,
          user_id: user.uid,
        },
        { merge: true }
      );
    }

    // Stop any previous listener
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }

    this.unsubscribe = onSnapshot(ref, (docSnap) => {
      if (!docSnap.exists()) return;

      const data = docSnap.data();

      this.topics = normalize(data.topics);
      this.sources = normalize(data.sources);
      this.bookmarks = normalize(data.bookmarks);
      this.userId = data.user_id;

      console.log("🔥 Bookmarks updated:", this.bookmarks);

      this.isLoaded = true;
    });
  },
  */
  async load(user) {
    if (!user?.uid) return;
    if (this.userId === user.uid && this.isLoaded) return;

    this.userId = user.uid;
    const ref = doc(db, "preferences", user.uid);

    const snap = await getDoc(ref);
    if (!snap.exists()) {
      await setDoc(
        ref,
        {
          jurisdictions: null,
          industries: null,
          topics: null,
          subtopics: null,

          sources: null,
          bookmarks: null,
          user_id: user.uid,
        },
        { merge: true }
      );
    }

    // If an unsubscribe exists, stop it
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }

    // ⬅️ THIS IS THE IMPORTANT FIX
    // Return a promise that resolves on the FIRST snapshot
    return new Promise((resolve) => {
      this.unsubscribe = onSnapshot(ref, (docSnap) => {
        if (!docSnap.exists()) {
          resolve(); // resolve anyway
          return;
        }

        const data = docSnap.data();

        this.industries = normalize(data.industries);
        this.jurisdictions = normalize(data.jurisdictions);
        
        
        this.topics = normalize(data.topics);
        this.subtopics = normalize(data.subtopics);

        this.sources = normalize(data.sources);
        //this.bookmarks = normalize(data.bookmarks);
        this.bookmarks = Array.isArray(data.bookmarks)
        ? data.bookmarks
        : [];

        this.userId = data.user_id;

        this.isLoaded = true;
        resolve();  // resolve once data loaded
      });
    });
  },







  async save(fields = {}) {
    if (!this.userId) return;

    const ref = doc(db, "preferences", this.userId);

    const normalized = {};
    /*
    for (const key in fields) {
      normalized[key] = normalize(fields[key]);
    }*/
    for (const key in fields) {
      const value = normalize(fields[key]);
      if (value === undefined) continue;
      normalized[key] = value;
    }

    await setDoc(
      ref,
      {
        ...normalized,
        user_id: this.userId,
      },
      { merge: true }
    );
  },

async updateJurisdictions(jurisdictions) {
  await this.save({ jurisdictions });
},

  async updateIndustries(industries) {
    await this.save({ industries });
  },

  async updateTopics(topics) {
    await this.save({ topics });
  },

  async updateSubtopics(subtopics) {
    await this.save({ subtopics });
  },

  async updateSources(sources) {
    await this.save({ sources });
  },

  async updateBookmarks(bookmarks) {
    await this.save({ bookmarks });
  },

  detach() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  },

  reset() {

    this.jurisdictions = null;

    this.industries = null;

    this.topics = null;
    this.subtopics = null;

    this.sources = null;
    this.bookmarks = null;
    this.userId = null;
    this.isLoaded = false;

    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }
});
